import { flagsFromMe } from '@codex/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { HomePage } from '../auth/HomePage.js';
import { requireSession } from '../auth/require-session.js';
import { SessionError, SessionPending } from '../auth/SessionStates.js';
import { ShellHome } from '../shell/home.js';

/** `/`: the shell's home with the `shell` flag on, P0-2's placeholder home without it. */
export const Route = createFileRoute('/')({
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: HomeRoute,
});

function HomeRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  return flagsFromMe(me).shell ? <ShellHome me={me} /> : <HomePage />;
}
